class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const ak_count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountfordesk').innerHTML; 
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      // containerDesktop.innerHTML = count;
      containerDesktop.innerHTML = ak_count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }

     //NR custom code
    setTimeout(function() {
      price_range_filter();
      handleCheckboxChange();
    }, 1600);
    //NR custom code
    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);

     //NR custom code
      setTimeout(function() {
       price_range_filter();
        handleCheckboxChange();
      }, 1600);
      //NR custom code
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
/*
var PriceRangeSlider = class extends HTMLElement {
  connectedCallback() {
    console.log("Initializing PriceRangeSlider...");

    setTimeout(() => {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

      console.log("rangeLowerBound:", this.rangeLowerBound);
      console.log("rangeHigherBound:", this.rangeHigherBound);
      console.log("textInputLowerBound:", this.textInputLowerBound);
      console.log("textInputHigherBound:", this.textInputHigherBound);

      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

      this.textInputLowerBound.addEventListener("change", (event) => {
        if (event.target.value === '') {
          event.target.value = 0;
          this.textInputHigherBound.setAttribute('data-min', 0);
          this.rangeLowerBound.parentElement.style.setProperty("--range-min", `0%`);
        } else {
          let minValue = Math.max(
            Math.min(parseInt(event.target.value) || 0, parseInt(this.textInputHigherBound.value || event.target.max) - 1), 
            event.target.min
          );
          event.target.value = minValue;
          this.rangeLowerBound.value = minValue;
          this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(minValue / this.rangeLowerBound.max) * 100}%`);
        }
      });

      this.textInputHigherBound.addEventListener("change", (event) => {
        if (event.target.value === '') {
          event.target.value = Number(event.target.getAttribute('data-max'));
          this.textInputLowerBound.setAttribute('data-max', event.target.getAttribute('data-max'));
          this.rangeHigherBound.parentElement.style.setProperty("--range-max", `100%`);
        } else {
          let maxValue = Math.min(
            Math.max(parseInt(event.target.value) || 0, parseInt(this.textInputLowerBound.value || event.target.min) + 1), 
            event.target.max
          );
          event.target.value = maxValue;
          this.rangeHigherBound.value = maxValue;
          this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(maxValue / this.rangeHigherBound.max) * 100}%`);
        }
      });

      this.rangeLowerBound.addEventListener("input", (event) => {
        let minValue = Math.min(parseInt(event.target.value) || 0, parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        event.target.value = minValue;
        event.target.parentElement.style.setProperty("--range-min", `${(minValue / event.target.max) * 100}%`);
        this.textInputLowerBound.value = minValue;
      });

      this.rangeHigherBound.addEventListener("input", (event) => {
        let maxValue = Math.max(parseInt(event.target.value) || 0, parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        event.target.value = maxValue;
        event.target.parentElement.style.setProperty("--range-max", `${(maxValue / event.target.max) * 100}%`);
        this.textInputHigherBound.value = maxValue;
      });

      this.rangeLowerBound.addEventListener("change", () => {
        this.textInputLowerBound.value = this.rangeLowerBound.value;
      });

      this.rangeHigherBound.addEventListener("change", () => {
        this.textInputHigherBound.value = this.rangeHigherBound.value;
      });
    }, 500);
  }
};

window.customElements.define("price-range-slider", PriceRangeSlider);
*/

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



/*
if (document.body.classList.contains('template-collection')) {
  

// price filter slider
  const rangeMin = document.querySelector('.range-min');
  const rangeMax = document.querySelector('.range-max');
  const minValueInput = document.querySelector('.minvalue');
  const maxValueInput = document.querySelector('.maxvalue');
  const progress = document.querySelector('.price-range-progress');
  function updateInputs() {
    console.log("minValueInput",minValueInput)
    if (minValueInput) minValueInput.value = rangeMin.value;
    if (maxValueInput) maxValueInput.value = rangeMax.value;
  }

  function updateSlider() {
    if (minValueInput && maxValueInput) {
      rangeMin.value = minValueInput.value;
      rangeMax.value = maxValueInput.value;
    }
    updateProgress();
  }

  function updateProgress() {
    if(rangeMin || rangeMax ){
      const minPercent = (rangeMin.value / rangeMin.max) * 100;
      const maxPercent = (rangeMax.value / rangeMax.max) * 100;
      progress.style.left = minPercent + '%';
      progress.style.right = (100 - maxPercent) + '%';
    }
  }

  if (rangeMin) {
    rangeMin.addEventListener('input', () => {
      if (parseInt(rangeMin.value) > parseInt(rangeMax.value)) {
        rangeMin.value = rangeMax.value;
      }
      updateInputs();
      updateProgress();
    });
  }
  
  if (rangeMax) {
    rangeMax.addEventListener('input', () => {
      if (parseInt(rangeMax.value) < parseInt(rangeMin.value)) {
        rangeMax.value = rangeMin.value;
      }
      updateInputs();
      updateProgress();
    });
  }
  if(minValueInput){
    minValueInput.addEventListener('change', () => {
      if (parseInt(minValueInput.value) > parseInt(rangeMax.value)) {
        minValueInput.value = rangeMax.value;
      }
      updateSlider();
    });
  }

  if(maxValueInput){
    maxValueInput.addEventListener('change', () => {
      if (parseInt(maxValueInput.value) < parseInt(rangeMin.value)) {
        maxValueInput.value = rangeMin.value;
      }
      updateSlider();
    });
  }
  // Initial update
  updateInputs();
  updateProgress();

// price range for mobile 

  const mobileRangeMin = document.querySelector('.mobile-range-min');
  const mobileRangeMax = document.querySelector('.mobile-range-max');
  const mobileMinValueInput = document.querySelector('.Mobile-Filter--minvalue');
  const mobileMaxValueInput = document.querySelector('.Mobile-Filter--maxvalue');
  const mobileProgress = document.querySelector('.mobile-price-rang');
  const removeButton = document.querySelector('.mobile-price-range');

  if (!mobileRangeMin || !mobileRangeMax || !mobileMinValueInput || !mobileMaxValueInput || !mobileProgress) {
    console.error('One or more elements not found. Check your HTML structure and class names.');
  }

  function mobileupdateInputs() {
    if(mobileMinValueInput || mobileMaxValueInput ){
      mobileMinValueInput.value = mobileRangeMin.value;
      mobileMaxValueInput.value = mobileRangeMax.value; 
    }
  }

  function mobileupdateSlider() {
    mobileRangeMin.value = mobileMinValueInput.value;
    mobileRangeMax.value = mobileMaxValueInput.value;
    mobileupdateProgress();
  }

  function mobileupdateProgress() {
    if(mobileRangeMin || mobileRangeMax ){
      const minPercent = (mobileRangeMin.value / mobileRangeMin.max) * 100;
      const maxPercent = (mobileRangeMax.value / mobileRangeMax.max) * 100;
      mobileProgress.style.left = minPercent + '%';
      mobileProgress.style.right = (100 - maxPercent) + '%';
    }
  }
  if(mobileRangeMin){
    mobileRangeMin.addEventListener('input', () => {
      if (parseInt(mobileRangeMin.value) > parseInt(mobileRangeMax.value)) {
        mobileRangeMin.value = mobileRangeMax.value;
      }
      mobileupdateInputs();
      mobileupdateProgress();
    });
  }

  if(mobileRangeMax){
    mobileRangeMax.addEventListener('input', () => {
      if (parseInt(mobileRangeMax.value) < parseInt(mobileRangeMin.value)) {
        mobileRangeMax.value = mobileRangeMin.value;
      }
      mobileupdateInputs();
      mobileupdateProgress();
    });
  }

  if(mobileMinValueInput){
    mobileMinValueInput.addEventListener('change', () => {
      if (parseInt(mobileMinValueInput.value) > parseInt(mobileRangeMax.value)) {
        mobileMinValueInput.value = mobileRangeMax.value;
      }
      mobileupdateSlider();
    });
  }

  if(mobileMaxValueInput){
    mobileMaxValueInput.addEventListener('change', () => {
      if (parseInt(mobileMaxValueInput.value) < parseInt(mobileRangeMin.value)) {
        mobileMaxValueInput.value = mobileRangeMin.value;
      }
      mobileupdateSlider();
    });
  }
/* removeButton.addEventListener('click', () => {
  console.log("Button clicked");
  mobileupdateInputs();
  mobileupdateProgress();
}); */
  // Initial update
  //mobileupdateInputs();
  //mobileupdateProgress();
//}




//NR custom code
function price_range_filter() {
  console.log("Initializing price range filter");

  document.querySelectorAll('.category-toggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const parentLi = this.closest('li');
      parentLi.classList.toggle('expanded');
    });
  });

  if (window.matchMedia('(min-width: 1200px)').matches) {
    document.querySelectorAll('.haschild-links li').forEach(li => {
      li.addEventListener('mouseenter', function() {
        li.classList.add('expanded');
      });
    
      li.addEventListener('mouseleave', function() {
        li.classList.remove('expanded');
      });
    });
  }

  // Loop over all price range sliders (desktop and mobile)
  const allRangeGroups = document.querySelectorAll('.range-group');
  // .price_facet
  

  allRangeGroups.forEach(rangeGroup => {
    const main_price = rangeGroup.closest('.price_facet');
    const minRange = rangeGroup.querySelector('input[type="range"]:first-of-type');
    const maxRange = rangeGroup.querySelector('input[type="range"]:last-of-type');
    const minInput = main_price.querySelector('.price-input-min');
    const maxInput = main_price.querySelector('.price-input-max');

    const range_value = main_price.querySelector('.range_value');

    if (!minRange || !maxRange || !rangeGroup || !minInput || !maxInput) return;

    const defaultMin = parseInt(minRange.min) || 0;
    const defaultMax = parseInt(maxRange.max);

    function updateRangeUI(userChanged = false) {
      const minValue = parseInt(minRange.value);
      const maxValue = parseInt(maxRange.value);
      // const minPercent = (minValue / parseInt(minRange.max)) * 100;
      // const maxPercent = (maxValue / parseInt(maxRange.max)) * 100;
      const minPercent = (minValue / defaultMax) * 100;
      const maxPercent = (maxValue / defaultMax) * 100;

      rangeGroup.style.setProperty('--range-min', `${minPercent}%`);
      rangeGroup.style.setProperty('--range-max', `${maxPercent}%`);

      if (userChanged || minValue !== defaultMin || maxValue !== defaultMax) {
        minInput.value = minValue;
        maxInput.value = maxValue;

        // Restore names so filter applies
        minInput.setAttribute('name', minInput.dataset.name || 'filter.v.price.gte');
        maxInput.setAttribute('name', maxInput.dataset.name || 'filter.v.price.lte');
      } else {
        // Clear values and remove names to prevent auto-filter
        minInput.value = '';
        maxInput.value = '';
        minInput.removeAttribute('name');
        maxInput.removeAttribute('name');
      }

      if(range_value){
        // range_value.innerHTML = ((minValue).toFixed(2)) + ' - ' + ((maxValue).toFixed(2));
        range_value.innerHTML = `${minValue.toFixed(2)} - ${maxValue.toFixed(2)}`;
      }
    }

    function updateSlidersFromInputs() {
      // minRange.value = minInput.value;
      // maxRange.value = maxInput.value;
      // updateRangeUI();
      minRange.value = minInput.value || defaultMin;
      maxRange.value = maxInput.value || defaultMax;
      updateRangeUI(true);
    }

    // Slider to input
    minRange.addEventListener('input', () => {
      if (parseInt(minRange.value) > parseInt(maxRange.value)) {
        minRange.value = maxRange.value;
      }
       updateRangeUI(true);
    });

    maxRange.addEventListener('input', () => {
      if (parseInt(maxRange.value) < parseInt(minRange.value)) {
        maxRange.value = minRange.value;
      }
       updateRangeUI(true);
    });

    // Input to slider
    minInput.addEventListener('input', () => {
      if (parseInt(minInput.value) > parseInt(maxInput.value)) {
        minInput.value = maxInput.value;
      }
      updateSlidersFromInputs();
    });

    maxInput.addEventListener('input', () => {
      if (parseInt(maxInput.value) < parseInt(minInput.value)) {
        maxInput.value = minInput.value;
      }
      updateSlidersFromInputs();
    });

    // Initial sync
    updateRangeUI();
  });
}

//call price range
 price_range_filter();

document.addEventListener('DOMContentLoaded', function() {
  console.log('hihih')
//collection page showing products dropdown
const limitSelect = document.getElementById('limit');

if(limitSelect){
  limitSelect.addEventListener('change', function() {
    const url = new URL(window.location.href);
    const currentLimit = url.searchParams.get('limit');
    
    url.searchParams.set('limit', this.value);
    window.location.href = url.toString();
  });
}

// document.querySelectorAll('.category-toggle').forEach(toggle => {
//   console.log('hih')
//   toggle.addEventListener('click', function() {
//     console.log('hkhkhk')
//     const parentLi = this.closest('li');
//     parentLi.classList.toggle('expanded');
//   });
// });
});
//End NR custom code


//NR custom code
function handleCheckboxChange(){
  //desktop filters
  const filters = document.querySelectorAll(".collection_user_manuals .facet_filter_details.js-filter");

  function updateVisibility() {
    filters.forEach((filter, index) => {
      const checkboxes = filter.querySelectorAll("input[type='checkbox']");
      const anyChecked = Array.from(checkboxes).some(cb => cb.checked);

      // Hide this filter if ALL checkboxes inside it are hidden (e.g., due to display: none)
    const allCheckboxesHidden = Array.from(checkboxes).every(cb => cb.offsetParent === null);
    if (allCheckboxesHidden) {
      filter.classList.add("hidden");
      return; // Skip further logic for this filter
    } else {
      filter.classList.remove("hidden");
    }

      // Only show the next filter if current one has any checked
      if (index < filters.length - 1) {
        // console.log('index',index)
        const nextFilter = filters[index + 1];
        if (anyChecked) {
          nextFilter.classList.remove("hidden");
        } else {
          // Hide all filters beyond this one
          for (let i = index + 1; i < filters.length; i++) {
            filters[i].classList.add("hidden");
            // Optionally uncheck all checkboxes when hiding
            const nestedCheckboxes = filters[i].querySelectorAll("input[type='checkbox']");
            nestedCheckboxes.forEach(cb => cb.checked = false);
          }
        }
      }
    });
  }

  // Initial check on page load
  updateVisibility();

  // Add change event listener to all checkboxes
  filters.forEach(filter => {
    const checkboxes = filter.querySelectorAll("input[type='checkbox']");
    checkboxes.forEach(cb => {
      cb.addEventListener("change", updateVisibility);
    });
  });

  //mobile filters
  const filters_mobile = document.querySelectorAll(".collection_user_manuals .facet_filter_details_mobile.js-filter");

  function updateVisibility_mobile() {
    filters_mobile.forEach((filter, index) => {
      // filter.classList.add('hihihi');
      const checkboxes = filter.querySelectorAll("input[type='checkbox']");
      const anyChecked = Array.from(checkboxes).some(cb => cb.checked);

        // Hide this filter if ALL checkboxes inside it are hidden (e.g., due to display: none)
      const allCheckboxesHidden = Array.from(checkboxes).every(cb => cb.offsetParent === null);
      if (allCheckboxesHidden) {
        filter.classList.add("hidden");
        return; // Skip further logic for this filter
      } else {
        filter.classList.remove("hidden");
      }

      // Only show the next filter if current one has any checked
      if (index < filters_mobile.length - 1) {
        // console.log('index',index)
        // console.log('anyChecked',anyChecked);
        const nextFilter = filters_mobile[index + 1];
        if (anyChecked) {
          console.log('anyChecked',index);
          nextFilter.classList.remove("hidden");
        } else {
          // Hide all filters beyond this one
          for (let i = index + 1; i < filters_mobile.length; i++) {
            filters_mobile[i].classList.add("hidden");
            // Optionally uncheck all checkboxes when hiding
            const nestedCheckboxes = filters_mobile[i].querySelectorAll("input[type='checkbox']");
            nestedCheckboxes.forEach(cb => cb.checked = false);
          }
        }
      }
    });
  }

  // Initial check on page load
  updateVisibility_mobile();

  // Add change event listener to all checkboxes
  filters_mobile.forEach(filter => {
    const checkboxes = filter.querySelectorAll("input[type='checkbox']");
    checkboxes.forEach(cb => {
      cb.addEventListener("change", updateVisibility_mobile);
    });
  });
}
//End NR custom code
